import styled from "@emotion/styled";
import { FC } from "react";
import TextSimple from "../text-simple/TextSimple";

interface ILabelValueTextProps {
  label: string;
  value: string;
  position?: "col" | "row";
}

const LabelValueText: FC<ILabelValueTextProps> = props => {
  return (
    <Container position={props.position}>
      <TextSimple color="blue" size="sub-title" font="inter" weight="700">
        {`${props.label}${props.position !== "col" ? ":" : ""} `}
      </TextSimple>{" "}
      <TextSimple color="gray" size="sub-title" font="inter" weight="300">
        {props.value}
      </TextSimple>
    </Container>
  );
};

export default LabelValueText;

const Container = styled.div((props: { position?: "col" | "row" }) => {
  if (props.position === "col") {
    return `
            justify-content: start;
            display: flex;
            flex-direction: column
        `;
  }

  return `
    justify-content: start;
`;
});
